import { PlayIcon } from "@heroicons/react/24/solid";

/**
 * VideoLoadingAnimation component
 *
 * Loading state for the video player: the image-placeholder glyph (frame, sun, mountains, play
 * button), with the sun/mountain background panning right-to-left on a seamless loop while the
 * frame and play button stay fixed.
 */
export const VideoLoadingAnimation = () => {
  /* Render */
  return (
    <div data-testid="video-loading-animation" className="absolute inset-0 flex items-center justify-center">
      <div className="relative w-56 h-36 rounded-2xl overflow-hidden bg-[#f2318a] shadow-lg">
        <div className="video-loading-scroll-track absolute inset-0 w-[200%] h-full">
          <svg viewBox="0 0 400 260" preserveAspectRatio="none" className="block w-full h-full">
            <g fill="#f691c0">
              <circle cx="46" cy="60" r="24" />
              <circle cx="168" cy="46" r="12" opacity="0.75" />
              <polygon points="0,260 78,132 122,182 172,102 232,260" />
            </g>
            <g fill="#f691c0" transform="translate(200,0)">
              <circle cx="46" cy="60" r="24" />
              <circle cx="168" cy="46" r="12" opacity="0.75" />
              <polygon points="0,260 78,132 122,182 172,102 232,260" />
            </g>
          </svg>
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <PlayIcon className="size-11 text-[#7a1f45] drop-shadow-md" />
        </div>
      </div>
    </div>
  );
};
